import { Pipe, PipeTransform } from '@angular/core';
import {
    ReferencedAuthorityDto,
    SimpleAuthorityDto
} from '@flyfreely-portal-ui/flyfreely';

@Pipe({ name: 'formatMaintenanceAuthority' })
export class FormatMaintenanceAuthorityPipe implements PipeTransform {
    transform(
        authority: SimpleAuthorityDto | ReferencedAuthorityDto,
        currentAuthority?: SimpleAuthorityDto | ReferencedAuthorityDto,
        showIdentifier = false
    ) {
        if (
            authority == null ||
            !(authority instanceof Object) ||
            authority.authorityType == null ||
            authority.organisation == null
        ) {
            return 'None';
        }

        if (
            currentAuthority != null &&
            authority.id != null &&
            authority.id === currentAuthority.id
        ) {
            return 'This authority';
        }

        const authorityName =
            authority.authorityType.abbreviation != null
                ? authority.authorityType.abbreviation
                : authority.authorityType.name;

        const identifier =
            authority.identifier != null &&
            authority.authorityType.hasIdentifier
                ? `${authority.authorityType.identifierLabel} ${authority.identifier}`
                : '';

        return showIdentifier
            ? `${authority.organisation.name}'s ${authorityName} ${identifier}`
            : `${authority.organisation.name}'s ${authorityName}`;
    }
}
